import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Chevron Up icon for upward navigation
 */
export const ChevronUpIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polyline points="18 15 12 9 6 15"></polyline>
    </Icon>
  );
};

export default ChevronUpIcon;
